import useApi from '../api';

const useVisitAbsencesService = () => {
    const { api } = useApi();

    return {
        // create: (data) => {
        //     return api.post('report', data).then((resp) => resp.data);
        // },
        // update: (data, id) => {
        //     return api.put(`report/${id}`, data).then((resp) => resp.data);
        // },
        getAllPendingVisitAbsences: (params) =>
            api
                .get('visit-absences/all-pending', {
                    headers: { 'Content-Type': 'application/json' },
                    params
                })
                .then((resp) => resp.data),
        getAllAbsenceReasons: () =>
            api
                .get('visit-absence-reasons', {
                    headers: { 'Content-Type': 'application/json' }
                })
                .then((resp) => resp.data),
        updateAbsenceReason: (id, data) =>
            api
                .put(`visit-absences/${id}`, data, {
                    headers: { 'Content-Type': 'application/json' }
                })
                .then((resp) => resp.data),
        getRegularityStatus: () =>
            api
                .get(`visit-absences/is-regular`, {
                    headers: { 'Content-Type': 'application/json' }
                })
                .then((resp) => resp.data)
    };
};

export default useVisitAbsencesService;
